import IMask from 'imask';
import {IMaskerOptionsArgs, InputMaskerOptions} from "~/helpers/inputMaskerOptions"

export default class InputMasker {
  public init(): void {
    let inputs = document.querySelectorAll('input[data-input-mask]');
    let percentageInputs = document.querySelectorAll('input[data-percentage-mask]');

    inputs.forEach(input => {
      InputMasker.initializeInputMasker(input);
    });
    percentageInputs.forEach(input => {
      InputMasker.initializePercentageMasker(input)
    });
  }

  static initializeInputMasker(input): void {
    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    let inputMaskType = input.getAttribute('data-input-mask') as IMaskerOptionsArgs['maskType'];
    let decimalPlaces: number = parseInt(input.getAttribute('data-decimal-places'), 0) || 0;

    const maskerOptions: IMask.AnyMaskedOptions = InputMaskerOptions({
      maskType: inputMaskType,
      decimalPlaces,
    }) || { mask: '' }

    // https://imask.js.org/guide.html
    let masker = IMask(input, maskerOptions);

    // 'accept' event fired on input when mask value has changed
    function triggeriMaskInputUpdate() {
      $(input).trigger("iMaskInputUpdate");
    };
    function handleMaskerAccept(){
      const hiddenInput = $(`:input[type="hidden"][data-id=${input.dataset.id}]`)
      triggeriMaskInputUpdate()
      //Used to fix bug where input masking did not work with conditionally read-only fields
      if(hiddenInput){
        hiddenInput.val(input.value)
      }

    }
    masker.on("accept", handleMaskerAccept);

    let updateMaskerValue = () => {
      // cleans up dangling space at the end
      input.value = input.value.trim();
      masker.updateValue(); // IMask wants us to do this
      masker.updateControl();
    };

    $(input).on('blur iMaskInput', () => { updateMaskerValue() });
  }

  static initializePercentageMasker(input): void {
    if (!(input instanceof HTMLInputElement)) {
      return;
    }
    $(input).on('input', () => {
      const hiddenInput = $(`:input[type="hidden"][data-id=${input.dataset.id}]`)
      if(hiddenInput) {
        hiddenInput.val(parseFloat(input.value) / 100)
      }
    })
  }
}
